module.exports = __webpack_public_path__ + "img/login-logo.3ca1a479.png";